import { Loading } from "@/components/ui/loading";

export const LoadingState = () => {
  return (
    <div className="min-h-screen bg-background p-6 flex items-center justify-center">
      <Loading text="Loading your information..." />
    </div>
  );
};
